import './Main.css'

import React, { useEffect, useMemo, useRef, useState } from 'react'
import DatePicker from 'react-datepicker'
import { useWizard } from '@/common/wizard/wizard'
import { useAppContext } from '@/context/app'
import { WizardData } from './Model'
import { fetchHTML, fetchPDF } from '@/common/fetch'

export interface SimpleMachineGroup {
  id: string
  name: string
}

export const MachinesReportWizardStep1 = () => {
  const { services, session, translates } = useAppContext()
  const { wizardData, updateWizardData, nextStep } = useWizard<WizardData>()
  const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));

  // @ts-ignore: Unreachable code error
  const ReactDatePicker = DatePicker.default ?? DatePicker;
  /* tslint:enable */

  function loadPDF() {
    fetchPDF({
      url: `/api/communal/my/reports/machinesranking/pdf?from=${wizardData.from.toISOString()}&to=${wizardData.to.toISOString()}&lang=${session?.user.lang}`,
      fileName: "machinesranking.pdf",
      services
    })
  }

  function loadHTML() {
    fetchPDF({
      url: `/api/communal/my/reports/machinesranking/pdf?type=html&from=${wizardData.from.toISOString()}&to=${wizardData.to.toISOString()}&lang=${session?.user.lang}`,
      fileName: "machinesranking.html",
      services
    })
  }

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  return <>
    <div>
      <h3>{translates.for('report.machinesranking.wizard.title')}</h3>

      <form className="main-form" onSubmit={(e) => {
        e.preventDefault()
        // updateWizardData(wizardData)
        nextStep()
      }}>

        <div className="form-field">
          <label htmlFor="from-date">{translates.for('report.machinesranking.wizard.from')}:</label>
          <ReactDatePicker
            id="from-date"
            name="from"
            selected={wizardData.from ? new Date(wizardData.from) : null}
            onChange={(date: Date | string) => {
              date = new Date(date)
              if (wizardData.to < date) {
                return
              }
              updateWizardData({
                ...wizardData,
                from: date || wizardData.from
              })
            }}
            showTimeSelect={true}
            timeIntervals={15}
            timeFormat="HH:mm"
            dateFormat="yyyy-MM-dd HH:mm"
            maxDate={wizardData.to || yesterday}
            // placeholderText="Select start date and time"
            className="border rounded p-2"
            portalId="tooltip-wrap"
          />
        </div>

        {/* To Date */}
        <div className="form-field">
          <label htmlFor="to-date">{translates.for('report.machinesranking.wizard.to')}:</label>
          <ReactDatePicker
            id="to-date"
            name="to"
            selected={wizardData.to ? new Date(wizardData.to) : null}
            onChange={(date: Date | string) => {
              date = new Date(date)
              if (wizardData.from > date) {
                return
              }
              updateWizardData({
                ...wizardData,
                to: date || wizardData.to
              })
            }}
            showTimeSelect
            timeIntervals={15}
            timeFormat="HH:mm"
            dateFormat="yyyy-MM-dd HH:mm"
            placeholderText=""
            minDate={wizardData.from || undefined}
            maxDate={yesterday}
            className="border rounded p-2"
            portalId="tooltip-wrap"
          />
        </div>

        <div className='right-btns'>
          <button className='btn btn-next' onClick={nextStep}>{translates.for('report.machinesranking.wizard.next')}</button>
          {/* <button type="button" className='btn btn-next' onClick={loadHTML}>{translates.for('report.machinesranking.wizard.gen_html')}</button> */}
          {/* <button type="button" className='btn btn-next' onClick={loadHTML}>HTML</button> */}
          <button type="button" className='btn btn-next' onClick={loadPDF}>{translates.for('report.machinesranking.wizard.gen_pdf')}</button>
        </div>
      </form>
    </div>
  </>
}
